import { Card, CardActionArea, CardContent } from 'ui';
import { FunctionComponent } from 'react';
import {
  IMAGE_SIZE_DESKTOP,
  itemizedCardActionAreaRootStyles,
  itemizedCardContentStyles,
  itemizedCardImageStyles,
  itemizedCardQuantityStyles,
  itemizedCardRootStyles,
} from 'components/business/menu/itemizedCardCssDefs';
import { Theme } from '@emotion/react';
import { Typography } from 'omakase';
import { centerCropUrl } from '@tock/images';
import { core } from '@tock/coretypes';
import LazyImage from 'components/images/LazyImage';

interface ItemizedCardProps {
  quantity?: number;
  image?: core.IUploadedImage;
  imageString?: string;
  disabled?: boolean;
  onClick?(): void;
  'data-testid'?: string;
}

const ItemizedCard: FunctionComponent<ItemizedCardProps> = ({
  children,
  quantity,
  image,
  imageString,
  disabled,
  onClick,
  'data-testid': dataTestId,
}) => {
  return (
    <Card variant="outlined" css={itemizedCardRootStyles}>
      <CardActionArea
        css={itemizedCardActionAreaRootStyles}
        disabled={disabled}
        disableRipple
        aria-haspopup={true}
        onClick={onClick}
        data-testid={dataTestId}
      >
        <CardContent
          css={(theme: Theme) =>
            itemizedCardContentStyles(theme, !!quantity && !image && !imageString)
          }
        >
          {children}
        </CardContent>
        {image ? (
          <LazyImage
            alt={image.altText || 'Image'}
            backgroundColor={image.dominantColor || ''}
            className=""
            css={itemizedCardImageStyles}
            src={centerCropUrl(image.imageBackingUrl || '', {
              width: IMAGE_SIZE_DESKTOP * 2,
              height: IMAGE_SIZE_DESKTOP * 2,
            })}
          />
        ) : null}
        {imageString ? (
          <LazyImage className="" css={itemizedCardImageStyles} src={imageString} />
        ) : null}
        {quantity ? (
          <Typography
            component="h6"
            variant="body02Strong"
            align="center"
            color="fgContrast"
            css={itemizedCardQuantityStyles}
          >
            {quantity}
          </Typography>
        ) : null}
      </CardActionArea>
    </Card>
  );
};

export default ItemizedCard;
